import {
    SingleIndexQuotes, HoldingResponseObj, EDISEncryptParams, EDISEncryptResponse,
    EDISInfo, EDISConfirmStatusResponse, HoldingResponse, EdisHoldingUpdateObj,
    PledgeEncryptParams, PledgeEncryptResponse, PledgeConfirmStatusResponse, SearchSymbolResults, SpecificSymbolResults, OtpMessageParams, BannedSymbol, EDISEncryptRevokeResponse, ContractDownloadInfo,
    MutualFundPledgeEncryptParams
} from './../app.interface';

import { StorageHelper } from './storage';
import { FilterValidators } from './sub-utils';
import {
    BOCOProductTypes, AdvanceOrder, TransactionStatus, SecondsIn, PlatformType,
    PledgeResponseStatus, PledgeStatus, ObjectKeyValue, Series, TransactionModes, CustomDateTimeFormat, Instrument, MarketKeywords, SortingTypes, BanType, EDISAction, StrategyIdType, ReportsColumns
} from 'sharedweb/app.structs';
import {
    GMT_IST_DIFFERENCE, GMT_IST_DIFFERENCE_SEC, REG_EX, MAX_EDIS_HOLDINGS, SYMBOL_SEARCH_ORDER_MARKET,
    SYMBOL_SEARCH_ORDER_INSTRUMENT_TYPE, SYMBOL_SEARCH_ORDER_CONTRACT_TYPE, DEFAULT_PRECISION, SECRET_KEY_LENGTH, DATE_TIME_FORMAT_UTILITY_IV, DATE_TIME_FORMAT_UTILITY_II, MAX_QUANTIY_IPO_INVESTOR_TYPE
} from './shared-constants';
import {
    ProfileResponse, MarginSummaryResponse, FundsTransactionReport,
    MarketWatchQuote, subscribeQuoteParams
} from 'sharedweb/app.interface';
import { OrderBook, Holding, MarketWatch, MutualFund } from 'sharedweb/app.models';
import { UntypedFormGroup, AbstractControl, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { MarketIDMap } from 'sharedweb/websocket.enums';
import * as memoizee from 'memoizee';
import { DiscountType, IPOListType, IPOStatus } from 'sharedweb/providers/ipo/ipo.structs';
import { Utils } from 'src/app/_helpers';
import { OtpGenerationType } from 'sharedweb/providers/utProto/enums_pb';
import { UserTypes } from 'src/app/app.structs';
import { BidDetails, DiscountStatus, TransformBidDetails } from 'sharedweb/providers/ipo/ipo.interface';

// tslint:disable-next-line:no-namespace
export namespace SharedUtils {

    export const storageHelper = new StorageHelper();
    /**
     * Utility Function to Check if User Pin
     * is enabled when user is looged in.
     */
    export function pinEnabled(): boolean {
        return (storageHelper.userInfo && storageHelper.userInfo.access_token && storageHelper.userInfo.twoFactorAuthentication);
    }

    export function _convertDateTime(modified: number) {
        const date = new Date();
        const dateInMilliseconds = date.getTime();
        if (modified > dateInMilliseconds) {
            modified = modified * 0.000001;
        } else {
            modified = modified * 1000;
        }
        return modified;
    }

    export function markTouched(form: UntypedFormGroup) {
        Object.keys(form.controls)
            .forEach(key => {
                const control = form.controls[key];
                if (control['controls'] && control['controls'].length) {
                    control['controls'].forEach(formGroup => {
                        markTouched(formGroup);
                    });
                }
                control.markAsTouched();
            });
        return;
    }


    /**
     * Function to Convert new line into <br> tag.
     */
    export function convertNewLines(input: string) {
        input = input.replace(/\\n/g, '\n');
        input = input.replace(/\\t/g, '\t');
        return input;
    }

    /**
     * This is utility function for adding delay in code (sleeping for some time)
     *
     * @param time Time for sleeping
     * @returns Promise after awaking
     */
    export function sleep(time: number = 0) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    export const filterValidator = new FilterValidators();


    export function nonBOCOProductType(productsMapped: Array<string>) {
        return productsMapped.filter(v => !BOCOProductTypes.includes(v as AdvanceOrder));
    }

    export const emptyTypes = [undefined, null];

    export function isNullUndefined(value: any) {
        return emptyTypes.includes(value);
    }

    export function epochToLocaleFormat(date = new Date(), seperator = '-') {
        let dd = date.getDate();
        let mm = date.getMonth() + 1;
        const yyyy = date.getFullYear();

        if (dd < 10) {
            dd = +('0' + dd);
        }
        if (mm < 10) {
            mm = +('0' + mm);
        }

        return dd + seperator + mm + seperator + yyyy;
    }

    /**
     * function to return array to objects, without duplicates, based on certain object property.
     * @param arr the array of objects
     * @param comp the property for comparison
     */

    export function getUnique(arr, comp) {
        const unique = arr
            .map(e => e[comp])

            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the dead keys & store unique objects
            .filter(e => arr[e])
            .map(e => arr[e]);

        return unique;
    }


    export function validateNumberOnly(event) {
        // accept numbers and backspace only
        const keycode = event.keyCode;
        if ((keycode < 48 || keycode > 57) && (keycode !== 8)) {
            event.preventDefault();
        }

    }

    /**
     * scripPrecision should be Math.pow(10, <actual_scrip_precision>)
     */
    export function isMultipleOfTickSize(tick: number, scripPrecision: number) {
        return (control: AbstractControl) => {
            const value = control.value;
            if (!value || isNaN(value)) {
                return { inValidNumber: true };
            }

            const valueInt = Math.round(value * scripPrecision);
            if ((valueInt % tick !== 0) || valueInt !== parseInt(valueInt.toString(), 10)) {
                return { tickSize: true };
            }
            return null;
        };
    }


    export function calculateTickSize(tick_size, scrip_precision) {
        return +(
            (tick_size / Math.pow(10, scrip_precision
            )).toFixed(scrip_precision));
    }

    export function getTimeGreetings() {
        const currentHour = (new Date()).getHours();

        if (currentHour >= 3 && currentHour < 12) {
            return 'Good Morning';
        } else if (currentHour >= 12 && currentHour < 15) {
            return 'Good Afternoon';
        } else if (currentHour >= 15 && currentHour < 20) {
            return 'Good Evening';
        } else if (currentHour >= 20 && currentHour < 3) {
            return 'Good Night';
        } else {
            return 'Good Night';
        }
    }

    /**
     * Function to Convert Camel Case  to Normal Sentences.
     */
    export function toSentence(str) {
        const result = str.replace(/([A-Z])/g, ' $1').replace(/^./, (replacedStr) => replacedStr.toUpperCase());
        return result;
    }


    /**
     * Utility method for checking if a value is valid integer or not
     *
     * @export
     * @param value Value that has to be checked
     * @returns boolean for valid or not.
     */
    export function isValidInteger(value: number) {
        return Math.round(value) === value;
    }

    /**
     * Function For converting rgb to hex
     */
    export function rgbToHex(hex: string) {
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        const rgb = r + ',' + g + ',' + b;
        return { r, g, b, rgb };
    }

    export function istToGmt(time: number): number {
        return time - (GMT_IST_DIFFERENCE);
    }

    export function gmtToIst(time: number): string {
        return Math.ceil((time + GMT_IST_DIFFERENCE) / 1000).toString();
    }

    export function getFromDate(resolution: string, isTradingView?: boolean) {

        const yesterday = new Date();

        if (isTradingView) {
            if (resolution.endsWith('m')) {
                yesterday.setDate(yesterday.getDate() - 1);
            } else if (resolution === '1h') {
                yesterday.setDate(yesterday.getDate() - 5);
            } else if (resolution === '1d') {
                yesterday.setMonth(yesterday.getMonth() - 1);
            } else {
                yesterday.setFullYear(yesterday.getFullYear() - 1);
            }
        } else {
            if (resolution[resolution.length - 1] === 'h' ||
                resolution[resolution.length - 1] === 'm') {
                yesterday.setDate(yesterday.getDate() - 1);
            } else if (resolution[resolution.length - 1] === 'd') {
                yesterday.setDate(yesterday.getDate() - 7);
            } else if (resolution[resolution.length - 1] === 'w') {
                yesterday.setMonth(yesterday.getMonth() - 1);
            } else {
                yesterday.setFullYear(yesterday.getFullYear() - 1);
            }
        }
        return gmtToIst(yesterday.getTime());
    }

    export function getToDate() {
        const today = new Date();
        return gmtToIst(today.getTime());
    }
    /**
     * Sort an array by a key in increasing as well as decreasing order.
     */
    export function sortByKey(key: string, reverse: SortingTypes) {
        return (a, b) => {
            if (reverse === SortingTypes.Descending) {
                return (a[key] < b[key]) ? 1 : -1;
            } else if (reverse === SortingTypes.Ascending) {
                return (a[key] > b[key]) ? 1 : -1;
            }
        };
    }

    /**
     * Find sorted index of new item in a sorted array of objects (linear search) for
     * small arrays.
     */
    export function findSortedIndex(array: any[], newItem: any, key: string) {
        if (!array.length || array[0][key] > newItem[key]) {
            return 0;
        }
        let i = 1;
        while (i < array.length && !(array[i][key] > newItem[key] &&
            array[i - 1][key] <= newItem[key])) {
            i = i + 1;
        }
        return i;
    }

    /**
     * Pass value or pass an array with colored columns in case of selected colored columns.
     */
    export function getColorClass(value: number, field?: string, coloredColumns?: string[]) {
        if (!coloredColumns || coloredColumns.includes(field)) {
            if (value > 0) {
                return 'profit';
            } else if (value < 0) {
                return 'loss';
            }
        }
    }

    export function getPrecisionColor(precision = DEFAULT_PRECISION, value: number): string {
        if (!value || (value && +(value.toFixed(precision)) == 0)) {
            return ''
        }
        const isNeg = value < 0;
        return isNeg ? 'loss' : 'profit';
    }

    export function getKeyVal(obj: object) {
        return {
            keys: Object.keys(obj),
            values: Object.values(obj)
        };
    }

    export function getInitials(info: ProfileResponse) {
        return `${info.first_name.charAt(0)}${info.last_name.charAt(0)}`.toUpperCase();
    }

    export function lotsCheck(order: OrderBook) {
        return order.lot_size > 1;
    }

    /**
     * Sort an array of objects acc. to a given order.
     */
    export function applySortingOrder(items: any[], newOrder: number[], key: string) {
        if (!newOrder || (newOrder && !newOrder.length)) {
            return items;
        } else {
            const order: number[] = newOrder;
            items.sort((a, b) => {
                const A = a[key];
                const B = b[key];

                if (order.indexOf(A) < order.indexOf(B)) {
                    if (order.indexOf(A) === -1) {
                        return 1;
                    }
                    return -1;
                } else if (order.indexOf(A) > order.indexOf(B)) {
                    return 1;
                }

                return 1;
            });
            return items;
        }
    }

    /**
     * Function that sorts symbol search results before displaying them
     * The sorting orders can be defined in the constants.
     *
     * Firstly, we are sorting on the basis of markets, secondly instrument type, thirdly
     * series and forthly, contract type
     */
    export function customSortForSymbolSearch() {
        return (a: SearchSymbolResults, b: SearchSymbolResults) => {
            return (SYMBOL_SEARCH_ORDER_MARKET.indexOf(a.market_id) - SYMBOL_SEARCH_ORDER_MARKET.indexOf(b.market_id)) ||
                (SYMBOL_SEARCH_ORDER_INSTRUMENT_TYPE.indexOf(a.instrument_type) -
                    SYMBOL_SEARCH_ORDER_INSTRUMENT_TYPE.indexOf(b.instrument_type)) ||
                (a.series !== b.series ? (a.series === Series.EQ ? -1 : (b.series === Series.EQ ? 1 : 0)) : 0) ||
                ((a.contract_type && b.contract_type) ? (SYMBOL_SEARCH_ORDER_CONTRACT_TYPE.indexOf(a.contract_type) -
                    SYMBOL_SEARCH_ORDER_CONTRACT_TYPE.indexOf(b.contract_type)) : 0);
        };
    }

    /**
     * Calculates the total Available Margin to be shown
     */
    export function totalAvailableFunds(marginSummary: MarginSummaryResponse, isAddOrWithdraw = false) {
        if (isAddOrWithdraw) {
            return marginSummary.total_margin_available;
        }
        return marginSummary.total_margin_available + marginSummary.pay_out + marginSummary.deductions;
        /**
         * cash_available is caluclated using below formula
            ((marginSummary.cash + marginSummary.adhoc + marginSummary.pay_in + marginSummary.custom_component +
            + marginSummary.option_sell_premium + marginSummary.collateral + marginSummary.credit_for_sale) -
            marginSummary.pay_out) - marginSummary.margin_utilized;
        */
    }

    export namespace FormValidations {
        function checkRegex(group: UntypedFormGroup | UntypedFormControl, regEx: string | RegExp) {
            let pass;
            if (group instanceof UntypedFormGroup) {
                pass = group.controls.password.value
            }
            else {
                pass = group.value;
            }
            const regex = new RegExp(regEx);
            return regex.test(pass);
        }

        export function containsSpecialCharacters(group: UntypedFormGroup | UntypedFormControl) {
            return checkRegex(group, REG_EX.contains_special_char) ? { containsSpecialChar: true } : null;
        }

        export function containsMixedCaseCharacters(group: UntypedFormGroup | UntypedFormControl) {
            return checkRegex(group, REG_EX.contains_mixed_case) ? null : { containsMixedCase: true };
        }

        export function containsDigit(group: UntypedFormGroup | UntypedFormControl) {
            return checkRegex(group, REG_EX.contains_digit) ? null : { containsDigit: true };
        }

        export function checkPasswords(group: UntypedFormGroup) {
            const pass = group.controls.password.value;
            const confirmPass = group.controls.confirmPassword.value;

            return pass === confirmPass ? null : { notSame: true };
        }

        export function checkPin(group: UntypedFormGroup) {
            const pin = group.controls.pin.value;
            const confirmPin = group.controls.confirmPin.value;

            return pin === confirmPin ? null : { notSame: true };
        }

        export function checkPhone(control: UntypedFormControl) {
            const value = control.value;

            // Regular expression to check if the value is a phone number
            const phoneRegex = /^\d+$/;

            if (value && phoneRegex.test(value) && value.length < 10) {
                return { phoneNumberInvalid: true };
            }
        }

        // This validator ensures that either both, the quantity and the price is entered or neither
        export function ipoBidValidator(group: UntypedFormGroup) {
            const qty = group.controls.quantity.value;
            const price = (group.controls.price || group.controls.rate).value;
            (group.controls.price || group.controls.rate).markAsTouched();
            group.controls.quantity.markAsTouched();
            return ((qty && !price) || (!qty && price)) ? { pairError: true } : null;
        }

        // This validator ensures that user has selected a symbol present in the smw-list, if they didn't then
        // expiry list for that leg will remain empty and this will throw an error 'symbol invalid'
        export function invalidSymbolValidator(expiryList: Map<number, string[]>, legIdx: any): ValidatorFn {
            return (c: AbstractControl): ValidationErrors | null => {
                if (c.value && expiryList.get(legIdx.val) && expiryList.get(legIdx.val).length == 0) {
                    return { symbolInvalid: true };
                }

                return null;
            }
        }
    }


    export function bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }

    export function getTransactionTime(row: FundsTransactionReport) {
        if (row.status === TransactionStatus.Pending) {
            return row.start_time;
        } else {
            return row.last_updated_time;
        }
    }

    /**
     * In case of deposit if cancel request is sent, the status is getting updated but user is still able
     * to do payment through the payment link generated. So not showing cancel option in case of deposit.
     */

    export function isTransactionCancellable(row: FundsTransactionReport) {
        return !(row.status === TransactionStatus.Cancelled ||
            row.status === TransactionStatus.Failed || row.status === TransactionStatus.Success ||
            row.mode === TransactionModes.Payin || row.mode === TransactionModes.Deduction);
    }

    export function indexChange(ltp: number, close: number) {
        return +(ltp - close).toFixed(2);
    }

    export function indexPerChange(change: number, close: number) {
        return ((change / close) * 100);
    }

    export function calculateAmountPayableIPO(bidsCtrls: UntypedFormControl[], discountStatus: DiscountStatus, isDiscounted: boolean = false) {
        let amountPayable = 0;

        bidsCtrls.forEach(el => {
            if (el.get('quantity').value && (el.get('rate') || el.get('price')).value) {
                const quantity = +el.get('quantity').value;
                const bidPrice = +((el.get('rate') || el.get('price')).value);
                const discount = isDiscounted ? discountAmount(discountStatus, bidPrice) : 0;
                const bidAmount = quantity * (bidPrice - discount);
                if (bidAmount > amountPayable) {
                    amountPayable = bidAmount;
                }

            }
        });

        return amountPayable;
    }

    export function discountAmount(discountStatus: DiscountStatus, amountPayable: number) {
        switch (discountStatus.discount_type) {
            case DiscountType.NO_DISCOUNT_ALLOWED:
                return 0;
            case DiscountType.IN_VALUE:
                return discountStatus.discount_value;
            case DiscountType.IN_PERCENTAGE:
                return (amountPayable * discountStatus.discount_value / 100);
        }
    }

    export function isBidCancelAllowed(bidDetails: TransformBidDetails[]): boolean {
        return bidDetails.every(bidDetail => {
            const bidAmount = +(bidDetail.quantity) * +(bidDetail.rate);
            return bidAmount < MAX_QUANTIY_IPO_INVESTOR_TYPE;
        });
    }

    /**
     * Converts index quote to symbol quote.
     */
    export function indexToSymbolQuote(quote: SingleIndexQuotes) {
        quote['last_trade_price'] = quote.value;
        quote['close_price'] = (quote as SingleIndexQuotes).close;

        // Open, high, low values doesn't come in live index quotes, so old values shouldn't be changed unecessarily.
        if ((quote as SingleIndexQuotes).open) {
            quote['open_price'] = (quote as SingleIndexQuotes).open;
            quote['high_price'] = (quote as SingleIndexQuotes).high;
            quote['low_price'] = (quote as SingleIndexQuotes).low;
        }

        return quote;
    }

    export function convertToFormattedDate(diff: number) {
        /*
            Takes time difference as parameter (in seconds)
            and returns the formatted relative time
        */
        const daydiff = Math.floor(diff / SecondsIn.DAY);
        if (isNaN(daydiff) || daydiff < 0 || daydiff >= 31) {
            return '';
        }

        return daydiff === 0 && (
            diff < SecondsIn.MINUTE && 'Just now' ||
            diff < 2 * SecondsIn.MINUTE && '1 minute ago' ||
            diff < SecondsIn.HOUR && Math.floor(diff / SecondsIn.MINUTE) + ' minutes ago' ||
            diff < 2 * SecondsIn.HOUR && '1 hour ago' ||
            diff < SecondsIn.DAY && Math.floor(diff / SecondsIn.HOUR) + ' hours ago') ||
            daydiff === 1 && 'Yesterday' ||
            daydiff < 7 && daydiff + ' days ago' ||
            daydiff < 31 && Math.ceil(daydiff / 7) === 1 && '1 week ago' ||
            daydiff < 31 && Math.ceil(daydiff / 7) + ' weeks ago';
    }

    export function getSecondsForTimeDuration(duration, separator = ':') {
        duration = duration.split(separator);
        const seconds = (+duration[0]) * 60 * 60 + (+duration[1]) * 60 + (+duration[2]);
        return seconds;
    }

    export function getTrendColorClass(val) {
        return val < 0 ? 'fg-loss' : 'fg-profit';
    }
    export function quotesCalculations(symbol: any, quote?: MarketWatchQuote) {

        if (quote) {

            if (quote.last_trade_price >= quote.close_price) {
                symbol.isTickUp = !(this.isTickDown = false);
            } else if (quote.last_trade_price < quote.close_price) {
                symbol.isTickDown = !(this.isTickUp = false);
            }

            Object.keys(quote).forEach(key => {
                if (key) {
                    symbol[key] = quote[key];
                }
            });
        }

        if (symbol.last_trade_time) {
            symbol.last_trade_time -= GMT_IST_DIFFERENCE_SEC;
        }

        if (symbol.last_update_time) {
            symbol.last_update_time -= GMT_IST_DIFFERENCE_SEC;
        }

        if (symbol.last_trade_price && symbol.close_price) {
            symbol.change_in_price = symbol.last_trade_price - symbol.close_price;
            symbol.perChange = ((symbol.change_in_price / symbol.close_price) * 100);
        }

        if (!quote) {
            symbol.isTickUp = symbol.perChange > 0;
            symbol.isTickDown = symbol.perChange < 0;
        }

        return symbol;
    }

    /**
     * Used to create a holding structure that is to be sent for encryption.
     * @param holdings: Holdings data
     * @returns '{isin, quantity, symbol}'
     */
    function getHoldingsForEDIS(holdings: Holding[], action) {
        const retHoldingsObj = [];
        holdings.forEach(el => {
            retHoldingsObj.push({
                isin: el.isin,
                quantity: ((action == EDISAction.Authorize) ? el.selected_auth_quantity : el.edis_auth_qty).toString(),
                symbol: el.symbol,
                transactions: el.transactions
            });
        }
        );
        return retHoldingsObj.slice(0, MAX_EDIS_HOLDINGS);
    }

    /**
     * Preps the data for encryption
     * @param holdings the holding data
     * @param userInfo user info
     * @param platform web or mobile
     * @param edisServerUrl callback url
     */
    export function prepDataForCDSLEncryption(
        holdings: Holding[],
        userInfo: EDISInfo,
        platform: PlatformType,
        edisServerUrl: string,
        action: EDISAction
    ) {
        const prepObject: EDISEncryptParams = {
            Version: '1.2',
            holdings: getHoldingsForEDIS(holdings, action),
            server_url: edisServerUrl,
            Platform: platform,
            bo_id: userInfo.bo_id,

        };
        return prepObject;
    }


    /**
     * Create a form object in memory to be submitted to CDSL
     * @param reference the reference of the DOM body
     * @param data data sent for encryption
     * @param response data recieved from the encryption response
     */
    export function createEDISForm(reference: any, data: EDISEncryptParams, response: EDISEncryptResponse) {
        const params = {
            DPId: response.dpID,
            ReqId: response.requestID,
            Version: data.Version,
            TransDtls: response.encryptedDetails
        };
        try {
            const form = reference.createElement('form');
            form.setAttribute('id', 'frmVerifyEDIS');
            form.setAttribute('method', 'post');
            form.setAttribute('action', response.redirectURL);
            form.setAttribute('name', 'frmDIS');
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = reference.createElement('input');
                    hiddenField.setAttribute('type', 'hidden');
                    hiddenField.setAttribute('name', key);
                    hiddenField.setAttribute('value', params[key]);
                    form.appendChild(hiddenField);
                }
            }
            return form;
        } catch (error) {
            console.log(error);
        }
    }

    export function createEDISRevokeForm(reference: any, data: EDISEncryptParams, response: EDISEncryptRevokeResponse) {
        const params = {
            DPId: response.dpID,
            RevocReqId: response.revocRequestID,
            Version: "1.0",
            RevokDtls: response.encryptedDetails
        };
        try {
            const form = reference.createElement('form');
            form.setAttribute('id', 'frmRevokeEDIS');
            form.setAttribute('method', 'post');
            form.setAttribute('action', response.redirectURL);
            form.setAttribute('name', 'frmDIS');
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = reference.createElement('input');
                    hiddenField.setAttribute('type', 'hidden');
                    hiddenField.setAttribute('name', key);
                    hiddenField.setAttribute('value', params[key]);
                    form.appendChild(hiddenField);
                }
            }
            return form;
        } catch (error) {
            console.log(error);
        }
    }

    /**
    * To check the number of pending and confirmed edis holdings and returns
    * updated holdings and other required numbers.
    * @param holdings response from the edis confirm status api
    * @param existingHoldings existing holdings on FE
    */
    export function updateHoldingStatus(holdings: EDISConfirmStatusResponse, existingHoldings: HoldingResponse, edisAction: EDISAction, selectedHoldings: Holding[]): EdisHoldingUpdateObj {
        let successCount = 0;
        if (edisAction == EDISAction.Unauthorize) {
            for (let holdingKey of Object.keys(selectedHoldings)) {
                if (selectedHoldings[holdingKey].edis_auth_qty > 0) {
                    const edisAuthQuantity = holdings[holdingKey];
                    const usernameISINKey = `${storageHelper.userInfo.username.toUpperCase()}:${holdingKey}`;
                    /**
                     * if holding is not in authorized holdings received from server and its original edis value is done
                     * meaning that its value is changed recently
                     */
                    if (!edisAuthQuantity) {
                        existingHoldings.data[usernameISINKey].is_edis_done = false;
                        existingHoldings.data[usernameISINKey].edis_auth_qty = 0;
                        successCount++;
                    }
                }
            }
        } else {
            Object.keys(holdings).forEach((ISIN) => {
                const quantity = holdings[ISIN];
                const holding = existingHoldings.data[`${storageHelper.userInfo.username.toUpperCase()}:${ISIN}`];
                if (selectedHoldings[ISIN]) {
                    const changeInEdisAuthQty = quantity - selectedHoldings[ISIN].edis_auth_qty;
                    if (changeInEdisAuthQty) {
                        successCount++;
                    }
                }
                if (holding !== undefined) {
                    holding.is_edis_done = (quantity === holding.total_qty);
                    holding.edis_auth_qty = quantity;
                }
            });
        }

        return {
            existingHoldings,
            successCount
        };
    }

    /**
 * Used to create a holding structure that is to be sent for encryption.
 * @param holdings: Holdings data
 * @returns '{isin, quantity}'
 */
    function getHoldingsForPledging(holdings: Holding[]) {
        const retHoldingsObj = [];
        holdings.forEach(el => {
            if (el.pledgable && el.pledge_check) {
                retHoldingsObj.push({
                    isin: el.isin,
                    quantity: +(el.quantity_to_pledge),
                });
            }
        });
        return retHoldingsObj;
    }

    /**
 * Preps the data for pledge encryption
 * @param holdings the holding data
 * @param userInfo user info
 * @param platform web or mobile
 * @param edisServerUrl callback url
 */
    export function prepDataForPledgeEncryption(
        holdings: Holding[],
        userInfo: EDISInfo,
        platform: PlatformType,
        edisServerUrl: string
    ) {
        const prepObject: PledgeEncryptParams = {
            pledgeebo: userInfo.bo_id,
            platform: platform,
            holdings: getHoldingsForPledging(holdings),
            server_url: edisServerUrl,

        };
        return prepObject;

    }
    /**
        * Used to create a mutual fund structure that is to be sent for encryption.
        * @param mutualFunds: MutualFund data
        * @returns '{isin, quantity}'
        */
    function getMutualFundsForPledging(mutualFunds: MutualFund[]) {
        const retMutualFundsObj = [];
        mutualFunds.forEach(fund => {
            if (fund.pledgeable && fund.pledge_check) {
                retMutualFundsObj.push({
                    isin: fund.isin,
                    quantity: +(fund.quantity_to_pledge),
                });
            }
        });
        return retMutualFundsObj;
    }
    /**
    * Preps the data for mutual fund pledge encryption
    * @param mutualFunds the mutual fund data
    * @param userInfo user info
    * @param platform web or mobile
    * @param edisServerUrl callback url
    */
    export function prepDataForMutualFundPledgeEncryption(
        mutualFunds: MutualFund[],
        userInfo: EDISInfo,
        platform: PlatformType,
        edisServerUrl: string
    ) {
        return {
            pledgeebo: userInfo.bo_id,
            platform: platform,
            holdings: getMutualFundsForPledging(mutualFunds),
            server_url: edisServerUrl,
        };
    }

    export function getMarginForRow(holding: Holding) {
        if (!holding.pledge_check) {
            return 0;
        }
        const margin = (holding.quantity_to_pledge * holding.close_price_value);
        const haircut = ((holding.haircut / Math.pow(10, holding.scrip_precision)) * margin) / 100;
        return margin - haircut;
    }

    export function getMarginForRowMutualFund(mutualFund: MutualFund) {
        if (!mutualFund.pledge_check) {
            return 0;
        }
        const margin = (mutualFund.quantity_to_pledge * mutualFund.currentNav);
        const haircut = ((mutualFund.hairCut / Math.pow(10, mutualFund.scrip_precision)) * margin) / 100;
        return margin - haircut;
    }

    export function getMarginForAllRows(holdings: Holding[]) {
        let result = 0;
        holdings.forEach(holding => {
            result = result + getMarginForRow(holding);
        });

        return result;
    }

    export function getMarginForAllRowsMutualFund(mutualFunds: MutualFund[]) {
        let result = 0;
        mutualFunds.forEach(mutualFund => {
            result = result + getMarginForRowMutualFund(mutualFund);
        });
        return result;
    }

    // Function to compare minimum and maximum amount to be entered.
    export function amountRangeValidator(minAmount: number, maxAmount: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const amount = parseFloat(control.value);
            if (amount < minAmount || amount > maxAmount) {
                return { amountRange: { minAmount, maxAmount } };
            }
            return null;
        };
    }

    // Function to compare minimum and maximum digits to be entered.
    export function digitLimitValidator(digitLimit: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const amount = control.value;
            if (amount) {
                const integerPart = amount.toString().split('.')[0];
                if (integerPart.length > digitLimit) {
                    return { digitLimit: { digitLimit } };
                }
            }
            return null;
        };
    }

    /**
     * Create a form object in memory to be submitted for pledging
     * @param reference the reference of the DOM body
     * @param data data sent for encryption
     * @param response data recieved from the encryption response
     */
    export function createPledgeForm(reference: any, data: PledgeEncryptParams | MutualFundPledgeEncryptParams, response: PledgeEncryptResponse) {
        const params = {
            dpid: response.dpID,
            reqid: response.requestID,
            version: '1.0',
            pledgedtls: response.encryptedDetails
        };
        try {
            const form = reference.createElement('form');
            form.setAttribute('id', 'frmVerifyPledge');
            form.setAttribute('method', 'post');
            form.setAttribute('action', response.redirectURL);
            form.setAttribute('name', 'frmpledge');
            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = reference.createElement('input');
                    hiddenField.setAttribute('type', 'hidden');
                    hiddenField.setAttribute('name', key);
                    hiddenField.setAttribute('value', params[key]);
                    form.appendChild(hiddenField);
                }
            }
            return form;
        } catch (error) {
            console.log(error);
        }
    }

    /**
    * function to sort expiry list.
    */
    export function sortExpiryList(response: SpecificSymbolResults[]) {
        let list: string[] = Array.from(new Set(response.map(r => r.expiry)))
        let listToSort = list.map(res => moment(res, CustomDateTimeFormat.moment_date_format));
        /**
         * the sort works as mentioned below:
         * if a is smaller than b, a is put at lower index than b
         * if b is smaller than a, b is put at lower index than a
         * if both are equal than positions are not changed.
         */
        listToSort.sort((a, b) => a.unix() - b.unix());
        return listToSort.map(res => res.format(CustomDateTimeFormat.moment_date_format));
    }

    /**
     * Function to check whether current device is mobile/tablet or not.
     * @returns true if current device is mobile/tablet else false.
     */
    export function mobileAndTabletCheck() {
        let check = false;
        (function (a) {
            // tslint:disable-next-line:max-line-length
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) { check = true; }
        })(navigator.userAgent || navigator.vendor);
        return check;
    }

    export function getDynamic(data: any, type: ObjectKeyValue) {
        const edisRequired = SharedUtils.storageHelper.edisRequired;
        switch (type) {

            case ObjectKeyValue.KEY:
                data = data.map(ele => ele[0]);
                if (!(!!edisRequired) && data.includes('is_edis_done')) {
                    data.splice(data.indexOf('is_edis_done'), 1);
                }
                break;
            case ObjectKeyValue.VALUE:
                data = data.map(ele => ele[1]);
                if (!(!!edisRequired) && data.includes('EDIS Status')) {
                    data.splice(data.indexOf('EDIS Status'), 1);
                }
                break;
            case ObjectKeyValue.KEYOBJECT:
                if (!(!!edisRequired) && data.includes('is_edis_done')) {
                    data.splice(data.indexOf('is_edis_done'), 1);
                }
                break;

            case ObjectKeyValue.DATA:
                if (!(!!edisRequired) && data.includes('EDIS Status')) {
                    data.splice(data.indexOf('EDIS Status'), 1);
                }
                break;
        }
        return data;
    }

    // RT-9347 Sorting IPOs Improvement
    export function SortIPO(ipo: any[]) {
        const priorityMap = {
            [IPOListType.ONGOING]: 1,    // Apply
            [IPOListType.PREAPPLY]: 2,   // Pre-apply
            [IPOListType.UPCOMING]: 3,    // Upcoming
            [IPOListType.RECENTLY_CLOSED]: 4       // Closed
        };

        return ipo.sort((a: any, b: any) => {
            const statusA = a.status;
            const statusB = b.status;

            // First sort by status priority


            const priorityA = priorityMap[statusA];
            const priorityB = priorityMap[statusB];

            if (priorityA !== priorityB) {
                return priorityA - priorityB;
            }

            // If same status, apply secondary sorting
            switch (statusA) {
                case IPOListType.ONGOING:
                case IPOListType.PREAPPLY:
                    // Sort by close date ascending for active IPOs
                    return a.close_time - b.close_time;
                case IPOListType.UPCOMING:
                    // Sort by open date ascending for upcoming
                    return a.open_time - b.open_time;
                case IPOListType.RECENTLY_CLOSED:
                    // Sort by close date descending for closed
                    return b.close_time - a.close_time;
                default:
                    return 0;
            }
        });
    }

    export function createStoreObject(data: any) {
        const newData: subscribeQuoteParams = {
            market_id: data.market_id ? parseInt(MarketIDMap[data.market_id]) : parseInt(MarketIDMap[data.marketId]),
            security_id: data.security_id,
            symbol_id: data.symbol_id,
            scrip_precision: data.scrip_precision ? data.scrip_precision : 2
        };
        return newData;
    }

    export function applyPrecision(number, precision) {
        const memoizedPower = memoizee(power);
        return parseFloat(number) / memoizedPower(precision);
    }

    function power(precision: number): number {
        return Math.pow(10, precision);
    }

    export function htonl(n: number) {
        // Mask off 8 bytes at a time then shift them into place
        const bits = [
            (n & 0xFF000000) >>> 24,
            (n & 0x00FF0000) >>> 16,
            (n & 0x0000FF00) >>> 8,
            (n & 0x000000FF) >>> 0,
        ]
        return bits;
    }

    /**
   * Convert a 32-bit quantity (long integer) from network byte order to host byte order (Big-Endian to Little-Endian).
   *
   * @param {Array|Buffer} b Array of octets or a Array Buffer to read value from
   * @param {number} i Zero-based index at which to read from b
   * @returns {number}
   */
    export function ntohl(b: Uint8Array, i: number = 0) {
        return ((0xff & b[i]) << 24) |
            ((0xff & b[i + 1]) << 16) |
            ((0xff & b[i + 2]) << 8) |
            ((0xff & b[i + 3]));
    };

    export function getUint64(dataview, byteOffset, littleEndian) {
        // split 64-bit number into two 32-bit (4-byte) parts
        const left = dataview.getUint32(byteOffset, littleEndian);
        const right = dataview.getUint32(byteOffset + 4, littleEndian);

        // combine the two 32-bit values
        const combined = littleEndian ? left + 2 ** 32 * right : 2 ** 32 * left + right;

        if (!Number.isSafeInteger(combined))
            console.warn(combined, 'exceeds MAX_SAFE_INTEGER. Precision may be lost');

        return combined;
    }

    export function presentSuccessOTPToast(otpGroup?: OtpMessageParams) {
        const clientObject = Utils.storageHelper.userInfo || otpGroup;
        const mssg = 'OTP has been sent to ' + clientObject.phone + ' and ' + clientObject.email;
        return mssg;
    }

    export function getOtpGenreationType(otpGroup: UntypedFormGroup): number {
        if (otpGroup.get('phone').value && otpGroup.get('email').value) {
            return OtpGenerationType.OTPGENERATIONTYPE_BOTH;
        } else if (otpGroup.get('phone').value) {
            return OtpGenerationType.OTPGENERATIONTYPE_SMS;
        } else if (otpGroup.get('email').value) {
            return OtpGenerationType.OTPGENERATIONTYPE_EMAIL;
        } else {
            return OtpGenerationType.OTPGENERATIONTYPE_MIN;
        }
    }

    // default from date is T - 1 month
    export function getReportDefaultDate(): Date {
        return moment().subtract('months', 1).toDate()
    }

    export function getMapKey(marketID: string, securityId: number) {
        const key = `${marketID}_${securityId}`;
        return key;
    }

    /**
   * 
   * @param symbolName Name of the symbol.
   * @param symbolInfo An array containing two values first will reflect asm_gsm Ban and second one is FO ban.
   */
    export function checkForBan(symbolName: string, symbolInfo: any[]) {
        let bannedSymbol: BannedSymbol;
        /**
         * If a symbol is not ban for ASM/GSM then the value for symbolInfo[0] would be 0, '' or 100.
         */
        if (symbolInfo[0] && symbolInfo[0] != 100) {
            bannedSymbol = { banType: BanType.ASM_GSM, symbolName, banCode: symbolInfo[0] as number };
        } else if (symbolInfo[1]) {
            bannedSymbol = { banType: BanType.FO, symbolName };
        } else {
            bannedSymbol = { banType: BanType.NONE, symbolName };
        }
        return bannedSymbol;
    }

    //  Genrate the BASE 32 string  
    export function generateRandomBase32String() {
        const length = SECRET_KEY_LENGTH;
        const base32Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
        let secret = '';
        /**this genrate the base32  random secret key which will be use to verify otp and totp  */

        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * base32Chars.length);
            secret += base32Chars[randomIndex];
        }
        return secret;
    }

    export function checkForAutoSquareOffOrder(strategy_id: number) {
        return ((storageHelper.userInfo.userType === UserTypes.dealer || storageHelper.userInfo.userType === UserTypes.client) && strategy_id === StrategyIdType.StrategyIdRms);
    }

    /**
     * Return  genrate the url for the hosted document . it replaces 'authorization' of the edis url with the 'contract note'
     * and append the path extract from the url , to result . 
     * 
     * @param url: it contans the url of the hosted document (eg. "http://14.97.59.74:50103/processing_root_folder/ShareIndia/
     * EquityContractNotes/75/individual_outputs/01S04_27-07-2023.pdf") .
     * @param edisServer: it contains the edis server url (eg ."http://10.0.0.62:4005/authorization/").
     * @returns  : retrn the custom  url edis_url+ hosted document path as document url  (eg "http://10.0.0.62:4005/contract_note/processing_root_folder/
     * ShareIndia/EquityContractNotes/75/individual_outputs/01S04_27-07-2023.pdf" ) 
     */
    export function getContractNoteDownloadUrl(url: string, edisServer: string): string {
        let documentUrl = edisServer;
        const replacingPart = 'authorization/';
        const newPart = 'contract_note';
        documentUrl = documentUrl.replace(replacingPart, newPart);
        return documentUrl + new URL(url).pathname;
    }

    /** 
     @param url :accepts the  url of hosted document .
     @param fileName :accepts the name , which is to be set as file name . 
    */
    export function downloadDocument(url: string, fileName: string): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            try {
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;

                // Append the <a> element to the DOM (but keep it hidden)
                a.style.display = 'none';
                document.body.appendChild(a);

                // Simulate a click event
                a.click();

                // Clean up: remove the <a> element from the DOM after a short delay
                setTimeout(() => {
                    document.body.removeChild(a);
                    resolve();
                }, 100);
            } catch (error) {
                reject(error);
            }
        });
    }

    //  create a file name using client_code ( client_code = username ) and date associated with the document . 
    export async function downloadContractDocument(reportData: ContractDownloadInfo, downloadUrl: string) {
        if (reportData.type && reportData.type == ReportsColumns.document_url) {
            const reportDate = formatDate(new Date(reportData.report.date), DATE_TIME_FORMAT_UTILITY_IV);
            const fileName = `${reportData.report.client_code}_${reportDate}.pdf`;
            await downloadDocument(downloadUrl, fileName);
        }
    }

    // returns the date in the provided format  
    export function formatDate(date: Date, dateFormat: string = DATE_TIME_FORMAT_UTILITY_II) {
        return moment(date).format(dateFormat);
    }
}

